"use strict";

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js-stable/object/define-property");
_Object$defineProperty(exports, "__esModule", {
  value: true
});
exports.initialized = exports.cancel = void 0;
const cancel = exports.cancel = '@event/CANCEL';
const initialized = exports.initialized = '@event/INITIALIZED';